var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VsChip',{staticClass:"m-0",class:{
    'text-orange-600': _vm.statusColor === 'warning',
    'text-green-600': _vm.statusColor === 'success'
  },attrs:{"color":_vm.statusColor,"transparent":""}},[(!_vm.inLoco)?_c('VsAvatar',{class:{
      'bg-blue-400': _vm.statusColor === 'primary',
      'bg-green-400': _vm.statusColor === 'success',
      'bg-red-400': _vm.statusColor === 'danger',
      'bg-orange-400': _vm.statusColor === 'warning'
    },attrs:{"icon":_vm.OrderTypeIcons[_vm.order.type],"color":_vm.statusColor === 'dark' ? '#888888' : ''}}):_vm._e(),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }